<template>
    <v-container class="text-start">
        <v-row>
            <v-col align="start">
                <h3 class="primary--text"> How do I pay by card? </h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="2">
                <v-img contain src="@/assets/PeachLogo.png" max-height="100" max-width="100"></v-img> 
            </v-col>
            <v-col>
                <v-img contain src="@/assets/visa.png" height="50" width="200"></v-img>
            </v-col>
        </v-row> 
        <v-row justify="center">
            <v-col>
                <ul class="white--text">
                    <li> On sign up you register your debit or credit card with our payment provider, Peach Payments. </li>
                    <li> Peach Payments make use of 3D secure tokenisation: <a href="https://www.peachpayments.com/" target="_blank"> www.peachpayments.com</a> </li>
                    <li> We accept all Visa & Master cards. </li>
                    <li> We only debit your account on delivery of our service. </li>
                </ul>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="start">
                <h3 class="primary--text"> How do I pay via EFT? </h3>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col>
                <ul class="white--text">
                    <li> An advanced payment can be made </li>
                    <li> Our bank details: Pay: WRAPP Tecnologies (Pty) Ltd (Dash Waste). Bank: Nedbank. Account number: 1131205936. Branch code: 198765 </li>
                    <li> Please use your name or company name as a reference. </li>
                    <li> Email proof of payment to <a href="mailto:info@dashwaste.co.za"> info@dashwaste.co.za</a> </li>
                </ul>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script>
export default {
    name: 'Payment',
    data () {
        return{

        }
        
    },
}
</script>
<style scoped>

</style>